import { render, staticRenderFns } from "./QuizResult.vue?vue&type=template&id=b7435c48&scoped=true&"
import script from "./QuizResult.vue?vue&type=script&lang=js&"
export * from "./QuizResult.vue?vue&type=script&lang=js&"
import style0 from "./QuizResult.vue?vue&type=style&index=0&id=b7435c48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7435c48",
  null
  
)

component.options.__file = "QuizResult.vue"
export default component.exports